import styled from '@emotion/styled';

export const StyledTabList = styled.div`
    border-bottom: 3px solid ${({ theme }) => theme.color.white200};
`;

export const StyledTab = styled.span`
    border: none;
    background-color: ${({ theme }) => theme.color.white100};
    outline: none;
    button {
        margin-left: 10px;
        margin-top: 10px;
        margin-bottom: 10px;
        height: auto !important;
        min-height: 40px;
        padding: 10px 16px !important;
    }
`;

export const TabTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[1]};
`;

export const TabTitle = styled.span`
    font-weight: 500;
`;

export const TabSubtitle = styled.span`
    font-size: 0.875rem;
    opacity: 0.7;
    font-weight: normal;
`;

export const StyledMobileTabList = styled(StyledTabList)`
    padding: 20px 20px;
`;
